/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

export default function () {

		const mobileNavigation = document.querySelector('.site-header__mobilenav');
		const desktopNavigation = document.querySelector('.site-header__desktopnav');
		// console.log('siteNavigation', mobileNavigation, desktopNavigation);

		const mobileSearch = document.querySelector('.site-header__search');
		const searchToggle = document.getElementById('search-toggle');

		// Return early if the navigation doesn't exist.
		if (!mobileNavigation || !desktopNavigation) {
			return;
		}

		const toggleButton = document.getElementById('menu-toggle');

		const subMenuActivators = document.querySelectorAll('.menu-item-has-children > button');

		// Return early if the button doesn't exist.
		if ('undefined' === typeof toggleButton) {
			return;
		}

		// Hide menu toggle button if menu is empty and return early.
		if ('undefined' === typeof mobileNavigation || !toggleButton) {
			toggleButton.style.display = 'none';
			return;
		}

		// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
		toggleButton.addEventListener('click', function () {
			if (mobileNavigation.classList.contains('toggled')) {
				closeMobileMenu();
			} else {
				openMobileMenu();
				closeSearch();
			}
		});

		if (mobileSearch && searchToggle) {
			searchToggle.addEventListener('click', function () {
				if (mobileSearch.classList.contains('toggled')) {
					closeSearch();
				} else {
					openSearch();
					closeMobileMenu();
				}
			});
		}

		function closeSearch() {
			mobileSearch.classList.remove('toggled');
			searchToggle.classList.remove('toggled');
			removeAria(searchToggle)
		}
		function openSearch() {
			mobileSearch.classList.add('toggled');
			searchToggle.classList.add('toggled');
			addAria(searchToggle)
		}

		function closeMobileMenu() {
			mobileNavigation.classList.remove('toggled');
			toggleButton.classList.remove('toggled');
			document.querySelector('body').classList.remove('locked');
			removeAria(toggleButton)
		}
		function openMobileMenu() {
			mobileNavigation.classList.add('toggled');
			toggleButton.classList.add('toggled');
			document.querySelector('body').classList.add('locked');
			addAria(toggleButton)
		}

		function removeAria(element) {
			element.setAttribute('aria-expanded', 'false');
			element.setAttribute('aria-expanded', 'true');
		}
		function addAria(element) {
			element.setAttribute('aria-expanded', 'true');
			element.setAttribute('aria-expanded', 'false');
		}

		if (subMenuActivators) {
			subMenuActivators.forEach((activator) => {
				activator.addEventListener('click', function () {
					const parent = this.parentElement;
					const subMenu = parent.querySelector('.sub-menu');
					const context = this;
					// console.log('a', parent, subMenu, context)
					if (subMenu.classList.contains('toggled')) {
						closeMenu(subMenu, parent, context);
					} else {
						closeOtherSubMenus(subMenu);
						openMenu(subMenu, parent, context);
					}
				});
			});
		}

		function closeOtherSubMenus(subMenu) {
			subMenuActivators.forEach((activator) => {
				const parent = activator.parentElement;
				const otherSubMenu = parent.querySelector('.sub-menu');
				if (otherSubMenu !== subMenu) {
					otherSubMenu.classList.remove('toggled');
					parent.classList.remove('toggled');
					activator.setAttribute('aria-expanded', 'false');
				}
			});
		}
		function closeMenu(subMenu, parent, context) {
			subMenu.classList.remove('toggled');
			parent.classList.remove('toggled');
			context.setAttribute('aria-expanded', 'false');
		}
		function openMenu(subMenu, parent, context) {
			// console.log('openMenu', subMenu, parent, context)
			subMenu.classList.add('toggled');
			parent.classList.add('toggled');
			context.setAttribute('aria-expanded', 'true');
		}
		function closeAllSubMenus() {
			subMenuActivators.forEach((activator) => {
				const parent = activator.parentElement;
				const subMenu = parent.querySelector('.sub-menu');
				subMenu.classList.remove('toggled');
				parent.classList.remove('toggled');
				activator.setAttribute('aria-expanded', 'false');
			});
		}

		// Close the desktop menu when the user clicks outside of it.
		document.addEventListener('click', function (event) {
			if (!desktopNavigation.contains(event.target) && !mobileNavigation.contains(event.target)) {
				// console.log("XXX")
				closeAllSubMenus();
			}
		});
}